/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Filename_PlaceholderInputs */

const en_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const fr_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const de_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const it_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const ru_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const es_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const zh_cn2_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const ja_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const hi_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

const pt_pt2_speakers_metrics_filename_placeholder = /** @type {(inputs: Speakers_Metrics_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Metrics`)
};

/**
* | output |
* | --- |
* | "Speaker Metrics" |
*
* @param {Speakers_Metrics_Filename_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_filename_placeholder = /** @type {((inputs?: Speakers_Metrics_Filename_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Filename_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_filename_placeholder(inputs)
	if (locale === "de") return de_speakers_metrics_filename_placeholder(inputs)
	if (locale === "it") return it_speakers_metrics_filename_placeholder(inputs)
	if (locale === "ru") return ru_speakers_metrics_filename_placeholder(inputs)
	if (locale === "es") return es_speakers_metrics_filename_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_filename_placeholder(inputs)
	if (locale === "ja") return ja_speakers_metrics_filename_placeholder(inputs)
	if (locale === "hi") return hi_speakers_metrics_filename_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_filename_placeholder(inputs)
	return en_speakers_metrics_filename_placeholder(inputs)
});